import { lazy } from 'react';

import LazyWithRetry from '../../components/shared/LazyWithRetry';
import LazyWithSuspense from '../../components/shared/LazyWithSuspense';

const MessageSettingsMainLazy = LazyWithSuspense(
    lazy(
        () =>
            LazyWithRetry(
                () => import('./MessageSettingsMain'),
                'message-settings',
            ) as any,
    ),
);

export default MessageSettingsMainLazy;
